<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('invoices.invoices_issuing.add_receptor') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div>
        <div class="form-wrapper p-4 overflow-x-auto overflow-y-auto" 
        :style="mobileVersion ? 'height: 80vh;' : 'height: 60vh;'">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-col"
          autocomplete="off">

        <!-- SOCIEDAD ------------------------------------------------>
          <div class="flex-1">
            <div class="flex flex-col lg:flex-row gap-x-6">
              <div class="w-full" v-if="(role === 7 || role === 8 || role === 3 )">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.entity_name')}}</label>
                <div class="flex justify-between">
                  <el-form-item prop="IdCliente" class="w-full">       
                    <el-select class="w-full" 
                      v-model="getIdCliente" 
                      :loading="loadingClientes" 
                      disabled>
                      <el-option
                        v-for="opt in clientes"
                        :key="opt.key"
                        :label="opt.label"
                        :value="opt.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <base-button v-if="isRoleUserConsultaProvider && false" class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading" type="button" />
                </div>
              </div>
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('agenda.sociedad') }}</label>
                <div class="flex justify-between">
                  <el-form-item prop="sociedad" class="w-full">       
                    <el-select class="w-full" 
                      clearable
                      filterable
                      allow-create
                      v-model="form.sociedad" 
                      :placeholder="$t('invoices.invoices_issuing.step3.validation_sociedad')"
                      :loading="loadingClientes" >
                      <el-option
                        v-for="opt in sociedades"
                        :key="opt.IdSociedad"
                        :label="opt.NameCorporateName"
                        :value="`${opt.NameCorporateName}-${opt.IdSociedad}`">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>

            <base-collapsible-form 
              v-if="isNewSociedad"
              ref="baseCollapsibleSociedad"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('agenda.sociedad') }}</h4>
              </template>
              <template slot="content">
                
                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('agenda.PersonTypeCode')}}</label>
                    <el-form-item prop="PersonType">
                      <el-switch 
                        class="switch-text break-normal both-switch" 
                        v-model="form.PersonType" 
                        :disabled="isRoleUserConsultaProvider"
                        :active-text="$t('tipos.persona.juridica')"
                        :inactive-text="$t('tipos.persona.fisica')"
                        inactive-color="var(--primary-800)"/>
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('invoices.invoices_issuing.step3.link_cif') }}</label>
                    <el-form-item prop="VincularCif">
                      <el-switch 
                        class="switch-text break-normal both-switch" 
                        v-model="form.VincularCif" 
                        :disabled="isRoleUserConsultaProvider"
                        :active-text="$t('app.yes')"
                        :inactive-text="$t('app.no')"
                        inactive-color="var(--primary-800)"/>
                    </el-form-item>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>
                      {{ form.PersonType? $t('companies.companyName') : $t('app.name') }}
                    </label>
                    <el-form-item prop="NameCorporateName">
                      <el-input
                        disabled
                        clearable
                        class="w-full"
                        v-model="form.NameCorporateName"
                        maxlength='80'/>
                    </el-form-item>
                  </div>
                  <div v-if="!form.PersonType" class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>
                      {{ $t('persons_data.firstsurname') }}
                    </label>
                    <el-form-item prop="FirstSurname">
                      <el-input
                        clearable
                        :disabled="isRoleUserConsultaProvider"
                        class="w-full"
                        v-model="form.FirstSurname"
                        maxlength='40'/>
                    </el-form-item>
                  </div>
                  <div v-if="!form.PersonType" class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">
                      {{ $t('persons_data.secondsurname') }}
                    </label>
                    <el-form-item prop="SecondSurname">
                      <el-input
                        clearable
                        :disabled="isRoleUserConsultaProvider"
                        class="w-full"
                        v-model="form.SecondSurname"
                        maxlength='40'/>
                    </el-form-item>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('agenda.ResidenceTypeCode')}}</label>
                    <el-form-item prop="ResidenceType">
                      <el-select class="w-full" 
                        v-model="form.ResidenceType"
                        :disabled="isRoleUserConsultaProvider">
                        <el-option
                          v-for="opt in tiposResidencia"
                          :key="opt.id"
                          :label="opt.name"
                          :value="opt.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                    
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('agenda.TaxIdentificationNumber')}}</label>
                    <el-form-item prop="TIN">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.TIN"
                        :disabled="isRoleUserConsultaProvider"
                        minlength="3"
                        maxlength='30'/>
                    </el-form-item>
                  </div>
                </div>

                <div v-if="false">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('tipos.pge.autofactura') }}</label>
                  <el-form-item prop="IsSeflInvoiceSociety">
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.IsSeflInvoiceSociety" 
                      :disabled="isRoleUserConsultaProvider"
                      :active-text="$t('app.yes')"
                      :inactive-text="$t('app.no')"/>
                  </el-form-item>
                </div>

                <div v-if="form.IsSeflInvoiceSociety" >
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.self_invoice_email') }}</label>
                  <el-form-item prop="SendEmailSelfInvoice">
                    <el-switch 
                      class="switch-text break-normal both-switch" 
                      v-model="form.SendEmailSelfInvoice" 
                      :disabled="isRoleUserConsultaProvider"
                      :active-text="$t('app.yes')"
                      :inactive-text="$t('app.no')"/>
                  </el-form-item>
                </div>
                            
                <base-collapsible-form 
                  v-if="form.PersonType"
                  ref="baseCollapsibleRegistrationData"
                  class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                  <template slot="headerRight">
                    <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.RegistrationData')}}</h4>
                  </template>
                  <template slot="content">
    
                    <div class="flex flex-col md:flex-row items-center gap-x-2">
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Book') }}</label>
                        <el-form-item prop="Book">
                          <el-input
                            clearable
                            :disabled="isRoleUserConsultaProvider"
                            class="w-full"
                            v-model="form.Book"
                            maxlength='20'/>
                        </el-form-item>
                      </div>
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.RegisterOfCompaniesLocation') }}</label>
                        <el-form-item prop="RegisterOfCompaniesLocation">
                          <el-input
                            clearable
                            :disabled="isRoleUserConsultaProvider"
                            class="w-full"
                            v-model="form.RegisterOfCompaniesLocation"
                            maxlength='20'/>
                        </el-form-item>
                      </div>
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Sheet') }}</label>
                        <el-form-item prop="Sheet">
                          <el-input
                            clearable
                            :disabled="isRoleUserConsultaProvider"
                            class="w-full"
                            v-model="form.Sheet"
                            maxlength='20'/>
                        </el-form-item>
                      </div>
                    </div>
                        
                    <div class="flex flex-col md:flex-row items-center gap-x-2">
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Folio') }}</label>
                        <el-form-item prop="Folio">
                          <el-input
                            clearable
                            :disabled="isRoleUserConsultaProvider"
                            class="w-full"
                            v-model="form.Folio"
                            maxlength='20'/>
                        </el-form-item>
                      </div>
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Section') }}</label>
                        <el-form-item prop="Section">
                          <el-input
                            clearable
                            :disabled="isRoleUserConsultaProvider"
                            class="w-full"
                            v-model="form.Section"
                            maxlength='20'/>
                        </el-form-item>
                      </div>
                      <div class="w-full">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Volume') }}</label>
                        <el-form-item prop="Volume">
                          <el-input
                            clearable
                            :disabled="isRoleUserConsultaProvider"
                            class="w-full"
                            v-model="form.Volume"
                            maxlength='20'/>
                        </el-form-item>
                      </div>
                    </div>
                      
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.additional_data') }}</label>
                      <el-form-item prop="AdditionalData">
                        <el-input
                          clearable
                          :disabled="isRoleUserConsultaProvider"
                          class="w-full"
                          v-model="form.AdditionalData"
                          maxlength='20'/>
                      </el-form-item>
                    </div>
                  </template>
                </base-collapsible-form>
              </template>
            </base-collapsible-form>
          </div>


          <!-- SEDE ------------------------------------------------>
          <base-collapsible-form 
            ref="baseCollapsibleSede"
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('sedes.entity_name') }}</h4>
            </template>
            <template slot="content">

              <div class="flex-1">
                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('app.name') }}</label>
                    <el-form-item prop="LocationName">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.LocationName"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"/>
                    </el-form-item>
                  </div>

                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('tipos.metadata.envio') }}</label>
                    <el-form-item prop="SendType">
                      <el-select class="w-full" 
                        v-model="form.SendType" 
                        clearable
                        filterable
                        :disabled="isRoleUserConsultaProvider">
                        <el-option
                          v-for="opt in tiposFormasEnvio"
                          :key="opt.id"
                          :label="opt.name"
                          :value="opt.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>

                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $tc('agenda.rol' ,2) }}</label>
                    <el-form-item prop="LocationRoles">
                      <el-select class="w-full" 
                        v-model="form.LocationRoles" 
                        multiple
                        clearable
                        filterable
                        :disabled="isRoleUserConsultaProvider">
                        <el-option
                          v-for="opt in tiposRolAgenda"
                          :key="opt.id"
                          :label="opt.name"
                          :value="opt.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
            

            <base-collapsible-form
              v-if="form.SendType === 'FACEB2B'"
              ref="baseCollapsibleFACEB2B"
              class="mt-2 mb-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('administrativecenter.data_faceb2b') }}</h4>
              </template>
              <template slot="content">
                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('app.name') }}</label>
                    <el-form-item prop="Name">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.Name"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"/>
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('companies.configuration_rec.dire') }}</label>
                    <el-form-item prop="DIRE">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.DIRE"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                </div>
              </template>
            </base-collapsible-form>

            <div class="flex flex-col md:flex-row items-center gap-x-2">
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.location') }}</label>
                <el-form-item prop="Address">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Address"
                    maxlength='40'
                    :disabled="isRoleUserConsultaProvider"/>
                </el-form-item>
              </div>
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.codigo_postal') }}</label>
                <el-form-item prop="PostCode">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.PostCode"
                    maxlength='40'
                    :disabled="isRoleUserConsultaProvider"/>
                </el-form-item>
              </div>
            </div>

            <div class="flex flex-col md:flex-row items-center gap-x-2">
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.poblacion') }}</label>
                <el-form-item prop="Town">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Town"
                    maxlength='40'
                    :disabled="isRoleUserConsultaProvider"/>
                </el-form-item>
              </div>
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.provincia') }}</label>
                <el-form-item prop="Province">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Province"
                    maxlength='40'
                    :disabled="isRoleUserConsultaProvider"/>
                </el-form-item>
              </div>
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.pais') }}</label>
                <el-form-item prop="CountryCode">
                  <base-el-select 
                    class="w-full" 
                    :options="listPaises" 
                    v-model="form.CountryCode" 
                    :placeholder="$t('app.select')"
                    :disabled="isRoleUserConsultaProvider" 
                    clearable 
                    filterable/>
                </el-form-item>
              </div>
            </div>

            <base-collapsible-form
              ref="baseCollapsibleRegistrationData"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.ContactDetails')}}</h4>
              </template>
              <template slot="content">

                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.telefono') }}</label>
                    <el-form-item prop="Telephone">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.Telephone"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.telefax') }}</label>
                    <el-form-item prop="TeleFax">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.TeleFax"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.WebAddress') }}</label>
                    <el-form-item prop="WebAddress">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.WebAddress"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.ElectronicMail') }}</label>
                    <el-form-item prop="ElectronicMail">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.ElectronicMail"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.cno_cnae') }}</label>
                    <el-form-item prop="CnoCnae">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.CnoCnae"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.INE_town_code') }}</label>
                    <el-form-item prop="INETownCode">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.INETownCode"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row items-center gap-x-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.ContactPersons') }}</label>
                    <el-form-item prop="ContactPersons">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.ContactPersons"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"/>
                    </el-form-item>
                  </div>
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.AdditionalContactDetails') }}</label>
                    <el-form-item prop="AdditionalDetails">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.AdditionalDetails"
                        maxlength='40'
                        :disabled="isRoleUserConsultaProvider"
                      />
                    </el-form-item>
                  </div>
                </div>
              </template>
            </base-collapsible-form>
          </div>
              </template>
          </base-collapsible-form>
        </el-form>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
        <base-button mode="secondary-phantom-blue" class="w-full mx-2" :text="$t('app.save')" @click="addSociedad('ruleForm')" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
// import DetailLayout from '@/components/layout/DetailLayout.vue'
import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'

import { getClients } from '@/services/clients/getClients'
import { getSociedadesSimple } from '@/services/configurations/getSociedadesSimple'
// import UserGeneratePasswordDialog from '@/components/UserGeneratePasswordDialog.vue'

export default {
  /* eslint-disable camelcase */
  name: 'new-reciever-dialog',
  components: {
    // DetailLayout,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    idCliente: [Number, String],
    idCIFEmpresa: [Number, String],
  },
  data: function () {
    return {
      searchView: false,
      isOpen: this.dialogOpen,
      activeName: 'es',
      form: this.getDefaultForm(),
      isNewSociedad: false,
      loadingClientes: false,
      sociedades: [],
      clientes: [],
      rules: {
        sociedad: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        NameCorporateName: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        FirstSurname: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        ResidenceType: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        TIN: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        LocationName: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        SendType: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        LocationRoles: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(i18n.t('validation.complete')))
              } else if (!value.includes(2)) {
                callback(new Error(i18n.t('invoices.invoices_issuing.step3.rol_client_validation')))
              } else {
                callback()
              }
            }
          },
        ],
        Address: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Town: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Province: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        CountryCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        PostCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
          {
            required: true,
            message: i18n.t('validation.length_min_number') + i18n.tc('app.n_character', 5),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (value) {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
        ],
        ElectronicMail: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        DIRE: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        CnoCnae: [
          {
            required: false,
            message: i18n.t('validation.length_min_number') + i18n.tc('app.n_character', 5),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (value) {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
        ],
      },
    }
  },
  computed: {
    getIdCliente: function () {
      return this.$store.getters['invoicesIssuing/form'].issuer.IdCliente
    },
    getIdCIFEmpresa: function () {
      return this.$store.getters['invoicesIssuing/form']?.issuer?.IdCIFEmpresa ?? ''
    },
    getNameCorporateName: function () {
      return this.form.sociedad
    },
    getPersonTypeCode () {
      return this.form.PersonType ? 'J' : 'F'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    hasAutofactura: function () {
      return !!this.$store.getters['auth/hasAutofacturaModule']
    },
    tiposRolAgenda: function () {
      return this.$store.getters['config/TIPOS_ROL_AGENDA']
    },
    tiposResidencia: function () {
      return this.$store.getters['config/TIPOS_RESIDENCIA']
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
    tiposFormasEnvio: function () {
      // Hay elementos duplicados 
      const sendType = new Set(this.$store.getters['config/TIPOS_PGE'].concat(this.$store.getters['config/TIPOS_PGE_RECEPCION']).map(JSON.stringify))
      return Array.from(sendType).map(JSON.parse)
    },
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value !== oldValue) {
        this.isOpen = !this.isOpen
        this.resetForm()
      }
    },
    'form.sociedad': function () {
      if (this.sociedades.length > 0) {
        if (this.form.sociedad) {
          const sociedadParams = this.form.sociedad.split('-')

          if (this.sociedades.some(element => element.NameCorporateName === sociedadParams[0])) {
            this.form.IdSociedad = parseInt(sociedadParams[1])
            this.isNewSociedad = false
          } else {
            this.form.NameCorporateName = this.getNameCorporateName
            this.isNewSociedad = true
          }
        } else {
          this.isNewSociedad = false
        }
      } else if (this.form.sociedad !== '') {
        this.form.NameCorporateName = this.form.sociedad
        this.isNewSociedad = true
      } else {
        this.isNewSociedad = false
      }
    },
    getIdCliente: async function () {
      this.sociedades = await this.getSociedades()
    }
  },
  async created () {
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(`${dataClients.msgError} [${dataClients.codError}]`)
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: x.idCliente }))
      this.loadingClientes = false
    } else {
      this.form.idCliente = this.getIdClientLogged
    }
  },
  mounted: async function () {
    this.sociedades = await this.getSociedades()
    // this.$refs.baseCollapsibleSede.toggle()
    // this.$refs.baseCollapsibleSociedad.toggle()
  },
  methods: {
    getDefaultForm: function () {
      return {
        sociedad: '',
        NuevaSociedad: false,
        VincularCif: true,
        idCifEmpresa: '',
        IdCliente: '',
        TIN: '',
        ResidenceType: '',
        PersonType: true,
        NameCorporateName: '',
        FirstSurname: '',
        SecondSurname: '',
        Book: '',
        RegisterOfCompaniesLocation: '',
        Sheet: '',
        Folio: '',
        Section: '',
        Volume: '',
        AdditionalData: '',
        SendEmailSelfInvoice: true,
        IdSociedad: '',
        LocationName: '',
        SendType: '',
        LocationRoles: [
          2
        ],
        Address: '',
        PostCode: '',
        Town: '',
        Province: '',
        CountryCode: '',
        Telephone: '',
        TeleFax: '',
        WebAddress: '',
        ElectronicMail: '',
        ContactPersons: '',
        CnoCnae: '',
        INETownCode: '',
        AdditionalDetails: '',
        DIRE: '',
        Name: '',
      }
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.isNewSociedad = false
      this.resetForm()
      this.$emit('toggleDialog')
    },
    resetForm () {
      this.form = this.getDefaultForm()
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return callback() // Campo opcional
      }
      if (!emailRegex.test(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },
    addSociedad: function (ruleForm) {
      try {
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (!valid) {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          } else {
            const params = {
              NuevaSociedad: !!this.form?.NameCorporateName || this.isNewSociedad,
              VincularCif: this.isNewSociedad,
              idCifEmpresa: this.getIdCIFEmpresa || this.idCifEmpresa,
              Sociedad: {
                IdCliente: this.idCliente || null,
                TIN: this.form?.TIN || null,
                ResidenceType: this.form?.ResidenceType || null,
                PersonType: this.getPersonTypeCode,
                NameCorporateName: this.form?.NameCorporateName || null,
                FirstSurname: this.form?.FirstSurname || null,
                SecondSurname: this.form?.SecondSurname || null,
                RegistrationData: {
                  Book: this.form?.Book || null,
                  RegisterOfCompaniesLocation: this.form?.RegisterOfCompaniesLocation || null,
                  Sheet: this.form?.Sheet || null,
                  Folio: this.form?.Folio || null,
                  Section: this.form?.Section || null,
                  Volume: this.form?.Volume || null,
                  AdditionalData: this.form?.AdditionalData || null
                },
                SendEmailSelfInvoice: this.form?.SendType === 'FACEB2B' || false
              },
              IdSociedad: parseInt(this.form?.sociedad?.split('-')[1]) || null,
              LocationName: this.form?.LocationName || null,
              SendType: this.form?.SendType || null,
              LocationRoles: this.form?.LocationRoles || null,
              Address: {
                Address: this.form?.Address || null,
                PostCode: this.form?.PostCode || null,
                Town: this.form?.Town || null,
                Province: this.form?.Province || null,
                CountryCode: this.form?.CountryCode || null
              },
              ContactDetails: {
                Telephone: this.form?.Telephone || null,
                TeleFax: this.form?.TeleFax || null,
                WebAddress: this.form?.WebAddress || null,
                ElectronicMail: this.form?.ElectronicMail || null,
                ContactPersons: this.form?.ContactPersons || null,
                CnoCnae: this.form?.CnoCnae || null,
                INETownCode: this.form?.INETownCode || null,
                AdditionalDetails: this.form?.AdditionalDetails || null
              },
              FACeB2BIdentificatives: {
                DIRE: this.form?.DIRE || null,
                Name: this.form?.Name || null
              }
            }

            this.$emit('applyDialog', params)
          }
        })
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getSociedades: async function () {
      const params = { 
        idCIFEmpresa: this.getIdCIFEmpresa || this.idCIFEmpresa,
        idCliente: this.getIdCliente ?? this.idCliente
      }
      const data = await getSociedadesSimple(params)
      if (data.blnError === true) {
        this.doFeedback(`${data.msgError} [${data.codError}]`)
      }
      return data.respuesta
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
.modal-overlay{
  z-index: 300;
}
</style>
